import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, calculateSpacing } from '@vds/theme';
import { IconData } from '@vds/icons';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { BreadcrumbItem as CoreBreadcrumbItem } from '@vds-core/breadcrumbs';

var BreadcrumbItem = function BreadcrumbItem(props) {
  return /*#__PURE__*/React.createElement(CoreBreadcrumbItem, _extends({}, props, {
    focusState: true,
    typescale: TypographyConfig.getTypescale(),
    colorConfig: colors,
    bodyConfig: BodyConfig,
    iconConfig: IconData,
    margin: "4",
    iconSpacing: calculateSpacing('1X')
  }));
};

export default BreadcrumbItem;